import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GET_ALL_STATES } from 'src/app/shared/graph-queries';
import { USState } from '../models/us-states.model';
import { map, Observable, of, shareReplay, tap } from 'rxjs';
import { SubmissionConstants } from 'src/app/modules/energy-credits/models/constants/submissions-constants';

@Injectable({
  providedIn: 'root',
})

export class UsStateService {
  stateList: USState[] = [];
  private statesCache$: Observable<USState[]> | null = null;

  constructor(
    private apolloClient: Apollo,
    private submissionConstants: SubmissionConstants
  ) {}

  /**
   * Getting all US States, including their climate zones.
   * Storing in local storage to prevent constant, subsequent queries when opening submissions.
   */
  getAllStates(): Observable<USState[]> {
    // Check local storage first
    const allStates = localStorage.getItem(this.submissionConstants.usStates);
    if (allStates) {
      const states = JSON.parse(allStates);
      this.stateList = states;
      return of(states);
    }

    if (this.statesCache$) {
      return this.statesCache$;
    }

    // If states + climate zone mapping are not stored, make Graph query
    this.statesCache$ = this.apolloClient
      .query<any>({
        query: GET_ALL_STATES,
      })
      .pipe(
        map((response) => response.data.GetAllStates),
        tap((states) => {
          this.stateList = states;
          localStorage.setItem(this.submissionConstants.usStates, JSON.stringify(states)
          );
        }),
      );

    return this.statesCache$;
  }
}
